import SSRIcon from '@ingka/ssr-icon'
import { space50 } from '@ingka/variables'

import styled from 'styled-components'

export const InputIcon = styled(SSRIcon)`
  position: absolute;
  right: ${space50};
`
